const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  allData: [],
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DATA":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      };
    case "DELETE_INVOICE":
      return { ...state };
    default:
      return { ...state };
  }
};
export default invoiceReducer;
